import * as React from 'react';
import lowerCase from 'lodash/lowerCase';
import { Field, FormSection } from '@atlaskit/form';
import { RadioGroup } from '@atlaskit/radio';

// TODO: Need to verify if this list can be fecthed from CCP or any other master source.
export const availablePricingPlan = [
  {
    name: 'commercial',
    value: 'commercial',
    label: 'Commercial',
    testId: `pricing-plan-grp-0`,
  },
  {
    name: 'community',
    value: 'community',
    label: 'Community',
    testId: `pricing-plan-grp-1`,
  },
  {
    name: 'academic',
    value: 'academic',
    label: 'Academic',
    testId: `pricing-plan-grp-4`,
  },
  {
    name: 'classroom',
    value: 'classroom',
    label: 'Classroom',
    testId: `pricing-plan-grp-3`,
  },
  {
    name: 'open-source',
    value: 'open_source',
    label: 'Open Source',
    testId: `pricing-plan-grp-2`,
  },
];

interface Props {
  pricingEligibility?: string | null;
  disabled?: boolean | false;
  title?: string;
}
const ChangePricingEligibility = ({ pricingEligibility, disabled, title = 'Select pricing eligibility' }: Props) => {
  const pricing = pricingEligibility ? lowerCase(pricingEligibility) : 'commercial';

  return (
    <>
      <FormSection>
        <h3>{title}</h3>
        <Field name="pricingPlan" isDisabled={disabled} isRequired id="pricing plan" defaultValue={pricing}>
          {({ fieldProps }) => <RadioGroup {...fieldProps} options={availablePricingPlan} name="pricingPlan" />}
        </Field>
      </FormSection>
    </>
  );
};
export default ChangePricingEligibility;
